import { useEffect } from "react";
import { useKeycloak } from "@react-keycloak/web";
import PreLoader from "../preLoader/PreLoader";

const AuthGate = ({ children }) => {
  const { keycloak, initialized } = useKeycloak();

  useEffect(() => {
    if (!initialized) {
      return;
    }

    if (!keycloak.authenticated) {
      keycloak.login();
    }
  }, [keycloak, initialized]);

  if (!initialized || !keycloak.authenticated) {
    return <PreLoader />;
  }

  return children;
};

export default AuthGate;
